export interface Department
{
    id: number;
    name: string;
    active: boolean;
    version: number;
    organizationId: number;
}

export interface OrganizationType
{
    id: number;
    displayName: string;
    code: string;
    icon?: any;
    version: number;
    codeSystem: string;
}

export class OrganizationDTO
{
    public id = 0;
    public version: number;
    public comments?: any;
    public name = '';
    public active: boolean;
    public createdBy: string;
    public lastModifiedBy: string;
    public lastModifiedDate: Date;
    public parentOrganization?: any;
    public createdOn: Date;
    public departments: Department[];
    public organizationType: OrganizationType;
    public address?: any;
    public firstName?: any;
    public lastName?: any;
    public title?: any;
    public email?: any;
    public homePhoneNumber?: any;
    public cellPhoneNumber?: any;
    public faxNumber?: any;
}

export class Extension
{
    public id = 0;
    public key = '';
    public name = '';
    public category = '';
    public organization = new OrganizationDTO();
    public enabled = true;
    public enabledNextAvailable = false;
    public allOrganizations = false;
    public allChannels = false;
    public channels: any[] = [];
    public required = false;
    public lastModifiedOn?: any;
    public lastModifiedBy: string;
    public billableItem = false;
}
